export default __webpack_public_path__ + "static/media/disabled-text-icon.7cf6dcef.svg";